export default __webpack_public_path__ + "static/media/LogoNoShadow-4x.a76e8897.png";